/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitDetailAliases {
  ACTION_PRINT = 'action-print',
  BREADCRUMB_0 = 'breadcrumb-0',
  CARD_HISTORIES = 'card-histories',
  CARD_HISTORY = 'card-history',
  CARD_HISTORY_MOBILE = 'card-history-mobile',
  CARD_INCONSISTENCY = 'card-inconsistency',
  CARD_INCONSISTENCY_MOBILE = 'card-inconsistency-mobile',
  CARD_VISIT_DATA = 'card-visit-data',
  CARD_VISIT_FORM = 'card-visit-form',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  DECK_FORM = 'deck-form',
  DECK_HISTORIES = 'deck-histories',
  DECK_HISTORY = 'deck-history',
  DECK_HISTORY_MOBILE = 'deck-history-mobile',
  DECK_INCONSISTENCY = 'deck-inconsistency',
  DECK_INCONSISTENCY_MOBILE = 'deck-inconsistency-mobile',
  DYNAMIC_CONTENT_FIELD_CARD_INCONSISTENCY = 'dynamic-content-field-card-inconsistency',
  FETCH_HISTORIES = 'fetch-histories',
  FETCH_HISTORY = 'fetch-history',
  FETCH_HISTORY_MOBILE = 'fetch-history-mobile',
  FETCH_INCONSISTENCY = 'fetch-inconsistency',
  FETCH_INCONSISTENCY_MOBILE = 'fetch-inconsistency-mobile',
  FETCH_VISIT_DATA = 'fetch-visit-data',
  FETCH_VISIT_FORM = 'fetch-visit-form',
  FIELD_0 = 'field-0',
  FIELD_AUDITOR = 'field-auditor',
  FIELD_CANCEL_REASON = 'field-cancel-reason',
  FIELD_DATE = 'field-date',
  FIELD_DATE_FORM = 'field-date-form',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_HISTORIES = 'field-histories',
  FIELD_HISTORIES_TITLE = 'field-histories-title',
  FIELD_HISTORY = 'field-history',
  FIELD_HISTORY_MOBILE = 'field-history-mobile',
  FIELD_INCONSISTENCIES = 'field-inconsistencies',
  FIELD_INCONSISTENCIES_MOBILE = 'field-inconsistencies-mobile',
  FIELD_INCONSISTENCY_MOBILE = 'field-inconsistency-mobile',
  FIELD_STATUS = 'field-status',
  FIELD_STATUS_INCONSISTENCY = 'field-status-inconsistency',
  FIELD_TITLE = 'field-title',
  FIELD_TITLE_HISTORY_MOBILE = 'field-title-history-mobile',
  FIELD_TYPE = 'field-type',
  LAYOUT_0 = 'layout-0',
  LAYOUT_DOUBLE = 'layout-double',
  LAYOUT_FORM = 'layout-form',
  LAYOUT_HEADER_HISTORIES = 'layout-header-histories',
  LAYOUT_HEADER_HISTORY = 'layout-header-history',
  LAYOUT_HEADER_HISTORY_MOBILE = 'layout-header-history-mobile',
  LAYOUT_HEADER_INCONSISTENCIES = 'layout-header-inconsistencies',
  LAYOUT_HEADER_INCONSISTENCIES_MOBILE = 'layout-header-inconsistencies-mobile',
  LAYOUT_HISTORIES = 'layout-histories',
  LAYOUT_HISTORY = 'layout-history',
  LAYOUT_HISTORY_MOBILE = 'layout-history-mobile',
  LAYOUT_INCONSISTENCIES = 'layout-inconsistencies',
  LAYOUT_INCONSISTENCIES_MOBILE = 'layout-inconsistencies-mobile',
  LAYOUT_MOBILE = 'layout-mobile',
  LAYOUT_ROOT = 'layout-root',
  LAYOUT_VISIT_DATA = 'layout-visit-data',
  LINK_APPOINTMENTS = 'link-appointments',
  LINK_APPOINTMENTS_MOBILE = 'link-appointments-mobile',
  LINK_HISTORY = 'link-history',
  LINK_INCONSISTENCIES = 'link-inconsistencies',
  LINK_INCONSISTENCIES_MOBILE = 'link-inconsistencies-mobile',
  PANEL_0 = 'panel-0',
  PANEL_DESKTOP = 'panel-desktop',
  PANEL_HISTORIES = 'panel-histories',
  PANEL_HISTORY = 'panel-history',
  PANEL_HISTORY_MOBILE = 'panel-history-mobile',
  PANEL_INCONSISTENCY = 'panel-inconsistency',
  PANEL_INCONSISTENCY_MOBILE = 'panel-inconsistency-mobile',
  PANEL_INCONSITENCIES = 'panel-inconsitencies',
  PANEL_LINK_APPOINTMENTS = 'panel-link-appointments',
  PANEL_LINK_APPOINTMENTS_MOBILE = 'panel-link-appointments-mobile',
  PANEL_LINK_INCONSISTENCIES = 'panel-link-inconsistencies',
  PANEL_LINK_INCONSISTENCIES_MOBILE = 'panel-link-inconsistencies-mobile',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_TECHNICAL_VISIT_DETAIL = 'panel-technical-visit-detail',
  PANEL_VISIT_DATA = 'panel-visit-data',
  PANEL_VISIT_FORM = 'panel-visit-form',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_DATE_FORM = 'text-date-form',
  TEXT_INCONSISTENCIES = 'text-inconsistencies',
  TEXT_INCONSISTENCIES_MOBILE = 'text-inconsistencies-mobile',
  TEXT_INCONSISTENCY_MOBILE = 'text-inconsistency-mobile',
  TEXT_SUGESTED_DATE = 'text-sugested-date',
  TEXT_SUGESTED_DATE_MOBILE = 'text-sugested-date-mobile',
  TEXT_SUGESTED_DATES = 'text-sugested-dates',
  TEXT_TITLE_FORM = 'text-title-form',
  TEXT_TITLE_HISTORIES = 'text-title-histories',
  TEXT_TITLE_HISTORY = 'text-title-history',
  TEXT_TITLE_HISTORY_MOBILE = 'text-title-history-mobile',
}
export { TechnicalVisitDetailAliases };
